export const dashboardStats = [
  {
    id: 1,
    title: 'Active Jobs',
    value: '24',
    change: '+12%',
    trend: 'up'
  },
  {
    id: 2,
    title: 'Total Licensees',
    value: '156',
    change: '+8%',
    trend: 'up'
  },
  {
    id: 3,
    title: 'Pending Quotes',
    value: '18',
    change: '-5%',
    trend: 'down'
  },
  {
    id: 4,
    title: 'Revenue This Month',
    value: '$284,500',
    change: '+23%',
    trend: 'up'
  }
];

export const recentJobs = [
  {
    id: 'JOB-2024-001',
    customer: 'Sarah Johnson',
    address: '1234 Oak Street, Portland, OR',
    type: 'Residential',
    status: 'In Progress',
    assignedTo: 'Precision Demo Co.',
    value: '$12,500',
    date: '2024-01-15'
  },
  {
    id: 'JOB-2024-002',
    customer: 'Michael Chen',
    address: '5678 Maple Avenue, Seattle, WA',
    type: 'Commercial',
    status: 'Quoted',
    assignedTo: 'Metro Demolition Services',
    value: '$45,000',
    date: '2024-01-14'
  },
  {
    id: 'JOB-2024-003',
    customer: 'Emily Rodriguez',
    address: '9012 Pine Road, Eugene, OR',
    type: 'Residential',
    status: 'Completed',
    assignedTo: 'Titan Wrecking LLC',
    value: '$8,900',
    date: '2024-01-13'
  },
  {
    id: 'JOB-2024-004',
    customer: 'David Thompson',
    address: '3456 Cedar Lane, Tacoma, WA',
    type: 'Residential',
    status: 'Pending',
    assignedTo: 'Unassigned',
    value: '$15,200',
    date: '2024-01-12'
  },
  {
    id: 'JOB-2024-005',
    customer: 'Lisa Martinez',
    address: '7890 Birch Street, Spokane, WA',
    type: 'Commercial',
    status: 'In Progress',
    assignedTo: 'Apex Demolition Group',
    value: '$67,800',
    date: '2024-01-11'
  }
];

export const licenseesList = [
  {
    id: 'LIC-001',
    company: 'Precision Demo Co.',
    contact: 'John Smith',
    email: 'john@precisiondemo.com',
    phone: '(555) 123-4567',
    rating: 4.8,
    completedJobs: 142,
    status: 'Active'
  },
  {
    id: 'LIC-002',
    company: 'Metro Demolition Services',
    contact: 'Amanda Wilson',
    email: 'amanda@metrodemo.com',
    phone: '(555) 234-5678',
    rating: 4.9,
    completedJobs: 198,
    status: 'Active'
  },
  {
    id: 'LIC-003',
    company: 'Titan Wrecking LLC',
    contact: 'Robert Brown',
    email: 'robert@titanwrecking.com',
    phone: '(555) 345-6789',
    rating: 4.7,
    completedJobs: 256,
    status: 'Active'
  },
  {
    id: 'LIC-004',
    company: 'Apex Demolition Group',
    contact: 'Jennifer Lee',
    email: 'jennifer@apexdemo.com',
    phone: '(555) 456-7890',
    rating: 4.6,
    completedJobs: 89,
    status: 'Active'
  }
];